import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { ReactComponent } from "react-formio";
import settingsForm from "./CustomPatientSelect.settingsForm";
import { RecoilRoot, useRecoilValue } from "recoil";
import { executeIntent } from "../../../../../experience/utils/IntentExecutor";
import IntentType from "../../../../../intentexecutor/utils/IntentType";
import { useReadMemory } from "../../../../../experience/generic/hooks/useReadMemory";
import MemoryType from "../../../../../service/memory/enum/MemoryType";
import { currentConfiguration } from "../../../../../service/memory/recoil/configurationstore";
import DebounceSelect from "../customselect/SearchAndSelect";

/**
 * An example React component
 *
 * Replace this with your custom react component. It needs to have two things.
 * 1. The value should be stored is state as "value"
 * 2. When the value changes, call props.onChange(newValue);
 *
 * This component is very simple. When clicked, it will set its value to "Changed".
 */
const CustomPatientSelectComponent = ({value, onChange}) => {

  const userJson = useReadMemory(MemoryType.USER);
  const configuration = useRecoilValue(currentConfiguration);
  // const secretKey = configuration[ConfigurationConstants.NIRAMAYA_ORGANIZATION_SECRETKEY];
  const [selectedValue, setSelectedValue] = useState([]);

  useEffect(() => {

    setSelectedValue([value?.patientSelected]);
    
  }, [configuration])

  async function fetchUserList(username) {
    const searchPayload = {
      query: username,
      organizationIdentifier: userJson?.organizationIdentifier,
      secretKey: "clXARby5dk5Iica2cXVGtg==",
      // secretKey: secretKey?.key,
    };
    const responseData = await executeIntent(IntentType.SEARCH_PATIENT, searchPayload);
    return responseData?.patientList?.map((user) => ({
          label: `${user.givenName} ${user.familyName}`,
          // value: `${user.givenName} ${user.familyName}`,
          value: JSON.stringify(user)
        }));
  }

  return <DebounceSelect
      showSearch
      allowClear
      value={selectedValue}
      // defaultValue={defaultValue[0]?.value}
      placeholder="Select patient"
      fetchOptions={fetchUserList}
      onChange={(newValue) => {
        setSelectedValue(newValue);
        onChange(newValue);
      }}
      style={{
        width: '100%',
      }}
    />
};

export default class CustomPatientSelect extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */

  static get builderInfo() {
    return {
      title: "Select Patient",
      icon: "square",
      group: "Data",
      documentation: "",
      weight: -10,
      schema: CustomPatientSelect.schema()
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema() {
    return ReactComponent.schema({
      type: "selectPatientComponent",
      label: "Select Patient Name",
      key: "patientSelected",
      input: true,
    });
  }

  /*
   * Defines the settingsForm when editing a component in the builder.
   */
  static editForm = settingsForm;

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */
  attachReact(element) {
    const defaultValue = this.data;
    return ReactDOM.render(
    <RecoilRoot>
      <CustomPatientSelectComponent
        component={this.component} // These are the component settings if you want to use them to render the component.
        label="select please"
        value={defaultValue}
        onChange={this.updateValue} // The onChange event to call when the value changes.
      />
    </RecoilRoot>,
      element
    );
  }

  /**
   * Automatically detach any react components.
   *
   * @param element
   */
  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
